import { Fragment, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, MenuItem, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { colors } from "../../css components/Style";
import { TextField, Autocomplete, Paper } from "../../../components";
import { signInMember } from "../../../redux/slices/memberSlice";

const WelcomeTypography = styled(Typography)`
  font-weight: 500;
  font-size: 2vw;
  color: rgba(0, 0, 0, 1);
`;

const Admin = styled.div`
  width: 110px;
  height: 110px;
  border-radius: 20px;
  font-size: 20px;
  color: #fff;
  align-item: center;
  background: ${colors.green};
  display: flex;
  margin: auto;
  justify-content: center;
`;

export default function AdminForm({ brands }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userID = sessionStorage.getItem("userID");
  const authToken = sessionStorage.getItem("authToken");
  const businessEntityId = sessionStorage.getItem("businessEntityId");

  const { dashboardState, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID,
    name: activeBrand.brandName,
    type: activeBrand.brandType,
    businessEntityID: activeBrand.bEntityID,
    admin: !activeBrand.ID && true,
  });

  const [userDashboardState, setUserDashboardState] = useState(
    dashboardState || "monetization"
  );

  const formikProps = {
    name: "brandID",
    values: {
      brandID: currentBrand.ID,
    },
    errors: {},
    touched: {},
  };

  return (
    <Fragment>
      <Paper style={{ width: "800px", margin: "80px auto" }}>
        <Grid style={{ margin: "auto" }} item xs={12} textAlign={"center"}>
          <Admin
            onClick={() => {
              setCurrentBrand({
                ID: "",
                name: "",
                type: "",
                admin: !currentBrand.admin,
              });
              setUserDashboardState("");
            }}
          >
            <Typography variant="h4" style={{ margin: "auto" }}>
              Admin
            </Typography>
          </Admin>
        </Grid>

        <Grid item xs={12} style={{ textAlign: "center" }}>
          <WelcomeTypography>OR login as</WelcomeTypography>
        </Grid>

        <Grid item xs={6} textAlign="left" marginTop={"5px"}>
          <Autocomplete
            name="brandID"
            placeholder="Select Brand Name"
            options={brands}
            defaults={{
              primaryKey: "ID",
              displayLabel: "brandName",
            }}
            disabled={currentBrand.admin}
            formikProps={formikProps}
            onChange={(_, value, type) => handleChangeBrand(value, type)}
          />
        </Grid>

        <Grid item xs={6} textAlign="left" marginTop={"5px"}>
          <TextField
            size="small"
            select
            inputProps={{ "aria-label": "Without label" }}
            name="role"
            value={userDashboardState}
            onChange={setDashboardUser}
            disabled={currentBrand.type !== 3}
          >
            <MenuItem selected value="">
              Select Role
            </MenuItem>
            <MenuItem value={`promotion`}>I am a Promotion Partner</MenuItem>
            <MenuItem value={`monetization`}>
              I am a Monetization Partner
            </MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} />

        <Grid item xs />
      </Paper>

      <div className="bottom-div">
        <Grid item style={{ paddingTop: "0px" }}>
          <CancelButton
            onClick={() => {
              navigate(pages.signIn.route);
            }}
            variant="outlined"
          >
            Cancel
          </CancelButton>
        </Grid>

        <Grid item style={{ paddingTop: "0px" }}>
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            disabled={!currentBrand.ID && !currentBrand.admin}
            onClick={async () => {
              sessionStorage.setItem("ps", "SA");
              if (currentBrand.admin) {
                sessionStorage.removeItem("");
                sessionStorage.setItem("role", "SUPER_ADMIN");
                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: businessEntityId,
                  })
                );

                navigate(pages.accountVerification.route);
              } else {
                sessionStorage.setItem("role", "NORMAL_USER");
                localStorage.setItem(
                  "dashboardState" + currentBrand.ID,
                  userDashboardState
                );

                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: currentBrand.businessEntityID,
                    brandType: currentBrand.type,
                  })
                );
                navigate(pages.brandDetails.route);
              }
            }}
          >
            Let's Go
          </PrimaryLoadingButton>
        </Grid>
      </div>
    </Fragment>
  );

  function handleChangeBrand(value, type) {
    if (type === "selectOption") {
      setCurrentBrand({
        ID: value.ID,
        name: value.brandName,
        type: value.brandType,
        businessEntityID: value.businessEntityID,
      });
      if (value.brand_type_id !== 3) {
        setUserDashboardState("monetization");
      }
      sessionStorage.setItem("activeBrand", value.ID);
      sessionStorage.setItem("brandType", value.brandType);
    } else {
      value = {
        brand_id: "",
        brand_name: "",
        brand_type: "",
        businessEntityID: "",
      };
      setCurrentBrand({
        ID: value.brand_id,
        name: value.brand_name,
        type: value.brand_type,
        businessEntityID: value.businessEntityID,
      });
      setUserDashboardState("");
    }
  }

  function setDashboardUser(e) {
    setUserDashboardState(e.target.value);
  }
}
